<h1 mat-dialog-title>Edit Location Info</h1>
<div mat-dialog-content>
    <div class="row m-2">
        <form class="col-sm-12 row" [formGroup]="locationInfoForm">
            <div class="row w-100 m-auto">
                <div class="col-sm-12 col-md-6 form-group">
                    <label for="province">Province</label>
                    <select class="form-control" id="province" formControlName="province_id" (change)='onProvinceSelected($event.target.value)'>
                        <option value="null" disabled [selected]="true">Choose the province</option>
                        <option *ngFor="let province of provinceList" [value]="province.id">{{ province.province }}</option>
                    </select>
                </div>
                <div class="col-sm-12 col-md-6 form-group">
                    <label for="district">District</label>
                    <select id="district" class="form-control" formControlName="district_id" (change)="onDistrictSelected($event.target.value)">
                        <option value="null" disabled [selected]="true">Choose the district</option>
                        <option *ngFor="let district of validDistrictList" [value]="district.id">{{ district.district }}</option>
                    </select>
                </div>
                <div class="col-sm-12 col-md-6 form-group">
                    <label for="municipality">Municipality</label>
                    <select id="municipality" class="form-control" formControlName="municipality_id" (change)="onMunicipalitySelected($event.target.value)">
                        <option value="null" disabled [selected]="true">Choose the municipality</option>
                        <option *ngFor="let municipality of validMunicipalityList" [value]="municipality.id">{{ municipality.municipality }}</option>
                    </select>
                </div>
                <div class="col-sm-12 col-md-6 form-group">
                    <label for="village">Village / Tole</label>
                    <input id="village" class="form-control" type="text" formControlName="village" placeholder="Enter the village">
                </div>
                <div class="col-sm-12 col-lg-6 form-group">
                    <label for="ward">Ward Number</label>
                    <input id="ward" class="form-control" type="number" formControlName="wardNumber" placeholder="Enter ward number">
                </div>
            </div>
            <form class="col-sm-12 row">
                <div class="form-group col-sm-12">
                    <label>Pin the location of your property</label>
                    <input #location placeholder="Search ..." class="form-control">
                </div>
                <div class="user-location-map" #mapContainer id="map"></div>
            </form>
        </form>
    </div>
</div>
<div mat-dialog-actions class="row col-sm-12 justify-content-end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="savePropertyLocationInfo()" cdkFocusInitial>Save</button>
</div>